<template>
  <div
    class="container flex-col flex-align-start mw-400 pad-top-30 pad-bottom-30"
  >
    <!-- <section>
      <h2 class="fs-large pad-top-20p pad-bottom-20">
        <b>
          Locale
          <span class="fc-primary">.ai</span>
        </b>
      </h2>

      <h3 class="item-header">Let's sign you up!</h3>
    </section> -->

    <h3 class="item-header">Let's get you signed up!</h3>
    <h4 class="item-subheader">Create your account on Locale.ai</h4>
    <form @submit.prevent="performRegister">
      <div class="flex-col mar-top-20">
        <label class="mar-bottom-5">Full Name</label>
        <input
          type="text"
          v-model="fullname"
          :placeholder="'Enter your full name'"
        />
      </div>
      <div class="flex-col mar-top-10">
        <label class="mar-bottom-5">Work Email</label>
        <input type="text" v-model="email" :placeholder="'Email address'" />
      </div>
      <label class="fc-error" v-if="emailError">Email already exists</label>
      <div class="flex-col mar-top-10 pad-bottom-5">
        <label class="mar-bottom-5">Password</label>
        <input type="password" v-model="password" :placeholder="'Password'" />
      </div>
      <label class="fc-error mar-top-10" v-if="passwordError"
        >Must be at least 6 letters long</label
      >
      <p class="mar-top-20">
        By continuing you accept our
        <a href="https://locale.ai" class="fc-primary">terms and conditions</a>
      </p>
      <div class="flex-center">
        <!-- sign in with google button -->
        <!-- <GoogleSignIn @success="gAuthSuccess" /> -->

        <!-- mind the gap :) -->
        <!-- <div class="flex-expand"></div> -->
        <Spinner v-if="isRequestInProgress" />
        <input
          type="submit"
          v-if="!isRequestInProgress"
          class="button"
          @click="registerUser()"
          value="Register"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { register, googleSignIn } from "@/api/auth";
import { validateEmail } from "@/lib/validations";
import GoogleSignIn from "@/components/auth/views/GoogleSignIn";
import { mapGetters, mapActions } from "vuex";
import { trackSignUp } from "../../../lib/analytics";
export default {
  components: {
    GoogleSignIn,
  },
  data: () => ({
    isPasswordVisible: false,
    fullname: "",
    email: "",
    password: "",
    company: "",
    isRequestInProgress: false,
    emailError: false,
    accountId: null,
    accountSignUp: false,
  }),
  methods: {
    ...mapActions("User", ["setAccountId", "signInWithGoogle", "signUp"]),
    ...mapActions("Popup", ["toggleVerifyEmailPopup"]),
    performRegister($event) {
      $event.preventDefault();
      this.registerUser();
    },
    gAuthSuccess: function(token) {
      this.isRequestInProgress = true;
      this.signInWithGoogle(token)
        .then(response => {
          if (response.status === 200) {
            this.$router.push("/");
          } else {
            throw new Error("Internal Server Error");
          }
        })
        .catch(error => {
          this.isRequestInProgress = false;
        });
    },
    registerUser: function() {
      if (validateEmail(this.email) && !this.passwordError && this.fullname) {
        this.isRequestInProgress = true;
        this.emailError = false;
        this.signUp({
          name: this.fullname,
          email: this.email,
          password: this.password,
          account_id: this.getAccountId,
        })
          .then(response => {
            this.isRequestInProgress = false;
            if (response.status === 200) {
              this.toggleVerifyEmailPopup();
              trackSignUp();
            }
          })
          .catch(error => {
            this.isRequestInProgress = false;
            if (error.response && error.response.status === 409) {
              this.emailError = true;
            }
          });
      } else {
        return;
      }
    },
    toggleVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
      if (this.isPasswordVisible) {
        this.$refs.passwordInput.setAttribute("type", "text");
      } else {
        this.$refs.passwordInput.setAttribute("type", "password");
      }
    },
  },
  computed: {
    ...mapGetters("User", ["getAccountId"]),
    // check if the password is proper
    passwordError() {
      if (this.password.length < 6) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    if (this.$route.query.account_id) {
      this.accountSignUp = true;
      this.accountId = this.$route.query.account_id;
      this.setAccountId(this.accountId);
    } else {
      console.error("No account Id found");
      this.$router.push("/auth");
    }
  },
};
</script>

<style lang="scss">
.mw-400 {
  max-width: 400px;
}
</style>
